import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phoneNumber',
    standalone: false
})

export class PhonePipe implements PipeTransform {
  transform(rawNum: string) {
    if (rawNum === null || rawNum === '' || rawNum === undefined) return '';
    
    const areaCodeStr = rawNum.slice(0, 3);
    const midSectionStr = rawNum.slice(3, 6);
    const lastSectionStr = rawNum.slice(6);

    return `(${areaCodeStr}) ${midSectionStr}-${lastSectionStr}`;
  }
}